require('swa-app-base/initialize');
require('./app/config/configure');
require('swa-app-base/post-initialize');

const run = require('swa-app-core/run');
const routes = require('./app/routes');

run(routes);